import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { FaAngleDoubleRight } from 'react-icons/fa';
import CardSkeleton from '../../Shared/CardSkelton/CardSkeleton';
import TvShow from '../Home/TvShow/TvShow';

const AllTvShows = () => {
    const { data: tvShows = [], isLoading } = useQuery({
        queryKey: ['tvShows'],
        queryFn: async () => {
            const res = await fetch(`https://api.themoviedb.org/3/tv/popular?api_key=60328c60edaea9ec7115178b6e8c7a3a`);
            const data = await res.json();
            return data.results;
        }
    })

    // console.log(tvShows);

    if (isLoading) {
        return (
            <div className='bg-[#090833] grid grid-cols-2 lg:grid-cols-5 md:grid-cols-3 gap-4 justify-between h-fit p-4 px-28 mt-20'>
                <CardSkeleton></CardSkeleton>
                <CardSkeleton></CardSkeleton>
                <CardSkeleton></CardSkeleton>
                <CardSkeleton></CardSkeleton>
                <CardSkeleton></CardSkeleton>
                <CardSkeleton></CardSkeleton>
                <CardSkeleton></CardSkeleton>
                <CardSkeleton></CardSkeleton>
                <CardSkeleton></CardSkeleton>
                <CardSkeleton></CardSkeleton>
            </div>
        )
    }
    return (
        <div className='lg:px-24 md:px-4 px-2 py-7 mt-12 bg-[#090833] text-white'>
            <div className="title flex items-center gap-1 align-middle">
                <h1 className='my-5 text-2xl inline-block rounded p-2 text-slate-200'>Latest Tv Show</h1>
                <span className='text-[#e6e101] inline-block text-2xl mt-[5px]'><FaAngleDoubleRight /></span>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-6 lg:gap-3 md:grid-cols-3 md:gap-3 sm:grid-cols-2 sm:gap-3">
                {


                    tvShows?.map((tvshow) => <TvShow tvshow={tvshow} key={tvshow?.id}></TvShow>)


                }
            </div>
        </div>
    );
};

export default AllTvShows;